import React from 'react'
// import './Footer.css'

function Footer() {
  return (
    <div className='footer text bg-[#B7202E] text-white text-center flex justify-center items-center h-[48px] w-full'>
      ©2025 KJSSE, All Rights Reserved.
    </div>
  )
}

export default Footer